import {CustomTag} from "../../../../domain";
import {TagDto} from "../dtos";

export const tagAggregateDtoDto = (customTag: CustomTag): TagDto => {
  return {
    name: customTag.name,
    type: customTag.type,
    color: customTag.color,
    tagId: customTag.id,
    companies: customTag.companiesIds
  }
}

export const tagDtoToCustomTag = (tagDto: TagDto): CustomTag => {
  return CustomTag.getInstance({
    tag: {
      name: tagDto.name,
      type: tagDto.type,
      color: tagDto.color,
      id: tagDto.tagId,
    },
    companies: tagDto.companies
  })
}
